export enum ActiveFilterEnum {
  ALL = 'all',
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}
